import { useEffect, useState } from 'react';
import useGontijoSession from 'hooks/useGontijoSession';
import { readGontijoAccountDetails } from '@/services/gontijo-session/gontijoAccountDetails';

/**
 * The signed-in Gontijo buyer's account, for the "Viajar como" offer on the passengers form.
 *
 * Null whenever there is nothing to offer: the tenant has no checkout login, there is no live
 * session, or the carrier's record could not be read. A failed read is not a reason to sign anybody
 * out — that verdict belongs to `validate_token` — so this only ever hides the offer.
 * @returns {{account: ?object, email: ?string}} The carrier's record and the sign-in email.
 */
export default function useGontijoAccountDetails() {
  const { enabled, isAuthenticated, token, email } = useGontijoSession();
  const [account, setAccount] = useState(null);
  const activeToken = enabled && isAuthenticated ? token : null;

  useEffect(() => {
    setAccount(null);
    if (!activeToken) return undefined;

    let isCurrent = true;

    readGontijoAccountDetails(activeToken).then((details) => {
      if (isCurrent) setAccount(details);
    });

    return () => {
      isCurrent = false;
    };
  }, [activeToken]);

  return { account, email: activeToken ? email : null };
}
